import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { ReactComponent as TagSolidIcon } from '../../../../assets/img/icons/icon--tag-solid.svg';

import { isColumnVisibleByDefault } from '../../../../utils/partialPermissionUtils';
import renderTags from './renderTags';

const tagsCol = (
  gantt,
  t,
  fieldNoPermission,
  triggerSetter,
  cursorCustomStyle
) => {
  const columnDefinition = {
    name: 'tags',
    label: 'Tags',
    data_type: 'array/images',
    visible: true,
    hide: !isColumnVisibleByDefault('tags'),
    span: 2,
    offset: 0,
    align: 'center',
    mode: 'multiple',
    from_values: 'toSelectTags',
    el_to_extract_from: 'id',
    el_to_label_from: ['name'],
    img_from: 'image',
    width: 125,
    groupable: false,
    groupable_switch: ['A → Z', 'Z → A'],
    orderable: false,
    orderable_switch: ['A → Z', 'Z → A'],
    filterable: true,
    resize: true,
    template: (task) => {
      return renderTags({
        column: columnDefinition,
        gantt,
        t,
        onlyRead: fieldNoPermission,
        task,
        mainObject: {},
        customMainClassName: ''
      });
    },
    templateExportable: (task) => {
      const currentGantt = window.to_use_react_gantt;
      if (!currentGantt) {
        return '';
      }

      let isOdd = false;
      if (currentGantt.oddColsConfig) {
        isOdd = currentGantt.oddColsConfig.tags;
      }

      const colClassName = isOdd ? 'odd-col' : 'non-odd-col';
      const { tags } = task;

      const tagsRender = tags.map((tag) => {
        const {
          description: tagDescriptionColor,
          name: tagName,
          id: tagId
        } = tag;

        const tagIconRender = (
          <div
            className="tag-column-template__icon"
            style={{ color: tagDescriptionColor }}>
            <TagSolidIcon />
          </div>
        );

        const tagNameRender = (
          <p className="tag-column-template__text">{tagName}</p>
        );

        return (
          <div key={tagId} className={'tag-column-template__item '}>
            {tagIconRender}
            {tagNameRender}
          </div>
        );
      });

      const tagTemplate = (
        <div className={`tag-column-template ${colClassName}`}>
          {tagsRender}
        </div>
      );

      const tagTemplateString =
        ReactDOMServer.renderToStaticMarkup(tagTemplate);
      return tagTemplateString;
    }
  };
  return columnDefinition;
};

export default tagsCol;
